import { React, useEffect, useState } from 'react';
import AdminCounts from './AdminCounts';

import Box from '@mui/material/Box';
import CampaignIcon from '@mui/icons-material/Campaign';
import CalculateIcon from '@mui/icons-material/Calculate';
import MarketingPanel from './MarketingPanel';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';



export default function AdminDashboard(props) {

    const [selectedTab, setSelectedTab] = useState(1);

    return (<div componentname='AdminDashboard'>
        
        <TabContext value={selectedTab} >
            <TabList
                className="AdminTabHeader"
                variant="fullWidth"
                textColor="primary"
                indicatorColor="secondary"
                onChange={(e, newValue) => setSelectedTab(newValue)} aria-label="Admin Tabs">
                <Tab value={1} label={<div><CalculateIcon style={{ marginRight: '1px' }} /> <div style={{ alignSelf: 'center', marginLeft: '1px' }}>Counts</div></div>} />
                <Tab value={2} label={<div><CampaignIcon style={{ marginRight: '1px' }} /> <div style={{ alignSelf: 'center', marginLeft: '1px' }}>Marketing</div></div>} />
            </TabList>

            <TabPanel value={1} index={0}>
                <div>
                    <AdminCounts loggedInUser={props.loggedInUser} />
                </div>
            </TabPanel>
            <TabPanel value={2} index={1}>
                <div style={{padding:'0px'} }>
                    <MarketingPanel loggedInUser={props.loggedInUser} />
                </div>
            </TabPanel>
        </TabContext>

      
        </div>
    )
}